export const NotificationCountLimit = 100
